<router-outlet />
<toast-notifications />
<version-no />
